import { useState } from 'react'
import {
	EuiBadge,
	EuiPopover,
} from '@equipmentshare/ds2'

import OrderedTable from '../OrderedTable'

import { PartsOrderedDetail } from '../../../../../graphql'

export type OrderedBadgeProps = {
	numOrdered?: number,
	orders?: PartsOrderedDetail[],
}

export default function OrderedBadge( { numOrdered, orders }: OrderedBadgeProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )

	if ( numOrdered && orders ) {
		const badge = (
			<EuiBadge
				onClick={() => setIsPopoverOpen( !isPopoverOpen )}
				onClickAriaLabel="View ordered details"
			>
				{numOrdered} Ordered
			</EuiBadge>
		)
		return (
			<EuiPopover
				isOpen={isPopoverOpen}
				closePopover={() => setIsPopoverOpen( false )}
				button={badge}
			>
				<OrderedTable
					orders={orders}
				/>
			</EuiPopover>
		)
	}

	return null
}
